module.exports = __webpack_public_path__ + "img/chart_push.c8dc9646.svg";